import { IHierarchyNode } from '@/shared/api-client/models/hierarchy-node';
import { Component, Prop, Vue } from 'vue-property-decorator';

export interface IHierarchyItemMetadata {
    nodeIndex: number;
    siblingsCount: number;
}

@Component({
    name: 'hierarchyComponent'
})
export default class HierarchyComponent<T, TBag> extends Vue {

    @Prop() public nodes!: IHierarchyNode<T>[];
    @Prop({default: null}) public propertyBag!: TBag;

}
